/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Health { 
    /**
     * The git commit hash.
     */
    commit: string;
    /**
     * The database status.
     */
    database: Health.DatabaseEnum;
    /**
     * The current app version.
     */
    app_version: string;
    /**
     * The REST API version.
     */
    api_version: string;
}
export namespace Health {
    export type DatabaseEnum = 'ok' | 'nok';
    export const DatabaseEnum = {
        Ok: 'ok' as DatabaseEnum,
        Nok: 'nok' as DatabaseEnum
    };
}